import React from "react";
import {
  Accordion as MUIAccordion,
  AccordionSummary as MUIAccordionSummary,
  AccordionDetails as MUIAccordionDetails,
} from "@mui/material";
import styled from "styled-components";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography } from "Components/Base/DataDisplay/Typography";

const StyledMUIAccordion = styled(MUIAccordion)`
  border-radius: 16px !important;

  .MuiAccordionSummary-content {
    margin: 12px 0;
    display: block;
  }

  .MuiAccordionDetails-root {
    padding: 0px 16px 16px !important;
  }

  &::before {
    content: unset !important;
  }
`;

export const Accordion = ({
  id,
  summaryText,
  detailsText,
  defaultExpanded = false,
  border = false,
  boxShadow = false,
  expandIcon = <ExpandMoreIcon />,
  summaryVariant = "h6",
}) => {
  const borderProp = border ? `1px solid var(--colorDivider)` : "none";
  const boxShadowProp = boxShadow ? "set" : "none";

  return (
    <StyledMUIAccordion
      id={id}
      style={{
        border: borderProp,
        boxShadow: boxShadowProp,
      }}
      defaultExpanded={defaultExpanded}
    >
      <MUIAccordionSummary expandIcon={expandIcon}>
        <Typography variant={summaryVariant}>{summaryText}</Typography>
      </MUIAccordionSummary>
      <MUIAccordionDetails>{detailsText}</MUIAccordionDetails>
    </StyledMUIAccordion>
  );
};
